import * as React from 'react';
import * as _ from 'lodash';
// TODO: import this from '@blend/ui-common' when we use ui-common from the registry
import { inputFormatters } from '@blend/shared-react';
import { SimpleDataTable } from '@blend/consumer-components';
import { getOrganizationColors } from 'login-utils/deploymentConfig';

export interface BuyingPowerSummaryProps {
  buyingPower: BuyingPowerFields;
}

export default class BuyingPowerSummary extends React.Component<BuyingPowerSummaryProps, {}> {
  getFormattedValue = (value: number | string, key: string) => {
    if (typeof value === 'string' || key === 'reserveMonths') return `${value}`;
    const formatPercentage = _.includes(['ltv', 'dti'], key) || key.match('Rate');
    return formatPercentage
      ? inputFormatters.PERCENTAGE.format(value * 100)
      : inputFormatters.MONEY_CENTS.formatWithDollarSign(value);
  };
  formatRow = (value: number, key: string) => {
    return [{ content: _.startCase(key) }, { content: this.getFormattedValue(value, key) }];
  };

  generateTableConfig = () => {
    const { buyingPower } = this.props;
    const rows = _.map(buyingPower, (value, key) => {
      return {
        cells: this.formatRow(value, key),
      };
    });
    return {
      headings: [{ content: 'Property' }, { content: 'Value' }],
      rows,
    };
  };

  render() {
    const tableConfig = this.generateTableConfig();
    const organizationColors = getOrganizationColors();
    const selectedRowColor = organizationColors.loginBackground;
    return (
      <SimpleDataTable
        caption="Here is your buying power based on the info you entered"
        tableConfig={tableConfig}
        selectedRowColor={selectedRowColor}
      />
    );
  }
}
